var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowSort({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "15px",
    viewBox: "0 0 16 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Sort") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "3.0-Practices",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "3.1a-Live-Practice",
    transform: "translate(-305.000000, -294.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Data--Default",
    transform: "translate(20.000000, 108.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Column-Sorted",
    transform: "translate(267.702808, 164.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-13",
    transform: "translate(18.297192, 22.500000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#000000",
    fill: "#FFFFFF",
    cx: 7,
    cy: 7,
    r: 7
  }), /*#__PURE__*/React.createElement("g", {
    id: "Sort-arrow",
    transform: "translate(3.000000, 3.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.49998462,3.49998462 L2.00001758,3.49998242 L4.59468489,0.905308527 C4.80179076,0.698202656 4.80179076,0.362417694 4.59468489,0.155311823 C4.38757902,-0.051794048 4.05179405,-0.051794048 3.84468818,0.155311823 L1.75802248e-05,3.99998242 L0.750014284,4.74997913 L3.84468818,7.84465303 C4.05179406,8.05175889 4.38757901,8.05175888 4.59468488,7.84465302 C4.80179074,7.63754715 4.80179075,7.3017622 4.59468489,7.09465632 L2.00001758,4.49998242 L7.49998462,4.49998023 C7.77612578,4.49998023 7.99998242,4.27612359 7.99998242,3.99998243 L7.99998242,3.99998243 C7.99998242,3.72384126 7.77612578,3.49998462 7.49998462,3.49998462 Z",
    id: "Shape",
    transform: "translate(4.000000, 3.999982) rotate(270.000000) translate(-4.000000, -3.999982) "
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowSort);
export default __webpack_public_path__ + "static/media/arrow_sort.1df54f38602ae85b20a8cbc585a5803f.svg";
export { ForwardRef as ReactComponent };